import "./RowDesignTool.0.css";

/* eslint-disable no-param-reassign */

import { designToolMixin } from "../../../../lib/helpers";
import { startMouseMove } from "../../../../lib/utils";
import { getLayoutAtPath, getLayoutSlot, getCompPathParentInfo } from "../../../../lib/utils/layout";
import FloatPortal from '../../../comps/Portal/FloatPortal';
import { isEqual, throttle } from "lodash-es";
const __script_base__ = {
  name: 'RowDesignTool',
  components: {
    FloatPortal
  },
  mixins: [designToolMixin],
  data() {
    return {
      draggingIndex: -1,
      draggingDisplay: ''
    };
  },
  mounted() {
    const columns = getLayoutSlot(this.comp, 'default', false) || [];
    if (columns.length === 1) {
      var _col$props, _col$props2;
      const col = columns[0];
      if ((_col$props = col.props) !== null && _col$props !== void 0 && _col$props.weight && ((_col$props2 = col.props) === null || _col$props2 === void 0 ? void 0 : _col$props2.weight) < 1) {
        this.$set(col, 'props', {
          ...col.props,
          weight: 1
        });
      }
    }
  },
  methods: {
    syncSize() {
      const defaultColProps = this.uc.components['w-col'].defaultProps;
      const actualEl = this.getCompInstance().$el;
      const {
        width: visualWidth,
        height: visualHeight
      } = actualEl.getBoundingClientRect();
      const rawColumns = getLayoutSlot(this.comp, 'default', false) || [];
      const totalWidth = actualEl.offsetWidth;
      this.totalWidth = totalWidth;
      this.visualWidth = visualWidth;
      this.visualHeight = visualHeight;

      /** @type {HTMLDivElement[]} */
      const children = Array.from(actualEl.children).slice(0, rawColumns.length);
      const newColumns = children.map((item, index) => {
        var _rawColumns$index;
        const left = item.offsetLeft;
        const width = item.offsetWidth;
        return {
          left,
          width,
          leftPercent: left / totalWidth * 100,
          widthPercent: width / totalWidth * 100,
          rightPercent: (width + left) / totalWidth * 100,
          props: {
            ...defaultColProps,
            ...(((_rawColumns$index = rawColumns[index]) === null || _rawColumns$index === void 0 ? void 0 : _rawColumns$index.props) || {})
          }
        };
      });
      // 有时候算不准 就让他再算一次
      if (!isEqual(newColumns, this.columns)) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      this.columns = newColumns;
    },
    insertColumn(index) {
      this.modifyComp(e => {
        const columns = getLayoutSlot(e, 'default');
        columns.splice(index, 0, {
          type: 'w-col'
        });
      });
    },
    deleteColumn(index) {
      const {
        compPath
      } = this;
      this.modifyComp((e, root) => {
        const columns = getLayoutSlot(e, 'default');
        const deleted = columns.splice(index, 1);
        if (!columns.length && deleted[0]) {
          var _deleted$;
          const {
            slotId,
            index,
            parentCompPath
          } = getCompPathParentInfo(compPath);
          const parentOfRow = getLayoutAtPath(root, parentCompPath);
          const slotOfRow = getLayoutSlot(parentOfRow, slotId);
          slotOfRow.splice(index, 1);
          const insertedItems = deleted === null || deleted === void 0 || (_deleted$ = deleted[0]) === null || _deleted$ === void 0 ? void 0 : _deleted$.children;
          if (insertedItems) slotOfRow.splice(index, 0, ...insertedItems);
        }
      });
    },
    selectColumn(index) {
      const {
        compPath
      } = this;
      this.designer.compPath = `${compPath}/default/${index}`;
    },
    setFixedWidth(index) {
      this.updateColumnProp(index, props => {
        const ans = prompt('输入新宽度（例如 200px）或者权重值', props.width || String(props.weight || 1));
        if (typeof ans !== 'string') return;
        const maybeWeight = +ans;
        if (!isNaN(maybeWeight) && maybeWeight > 0) {
          props.weight = maybeWeight;
          props.width = '';
        } else {
          props.width = ans;
        }
      });
    },
    /**
     * 修改某列的 prop 并提交
     *
     * @param {number} index
     * @param {string | (props: Object)=>void} editFnOrKey
     * @param {any} [value]
     */
    updateColumnProp(index, editFnOrKey, value) {
      this.modifyComp(e => {
        const column = getLayoutSlot(e, 'default')[index];
        if (!column.props) column.props = {};
        if (typeof editFnOrKey === 'string') column.props[editFnOrKey] = value;
        if (typeof editFnOrKey === 'function') editFnOrKey(column.props);
      });
    },
    startResizing(index, event) {
      const {
        target
      } = event;
      const width1 = this.columns[index].width;
      const width2 = this.columns[index + 1].width;
      let dX = 0;
      const quantizeFactor = 40;
      const resizeFactor = this.totalWidth / this.visualWidth;
      const widthQuantizeFactor = (width1 + width2) / quantizeFactor;
      this.draggingIndex = index;
      event.preventDefault();
      const getDraggingDisplay = () => {
        const defaultWeight = this.uc.components['w-col'].defaultProps.weight;
        const columns = getLayoutSlot(this.comp, 'default', false);
        const totalWeight = columns.slice(index, index + 2).map(item => {
          var _item$props;
          return ((_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.weight) || defaultWeight;
        }).reduce((a, b) => a + b);
        // eslint-disable-next-line no-mixed-operators
        const percent = Math.round((dX + width1) / (width1 + width2) * quantizeFactor) / quantizeFactor;
        return [totalWeight * percent, totalWeight * (1 - percent)].map(item => item.toFixed(2)).join(' : ');
      };
      const setProps = async () => {
        await this.modifyComp(e => {
          const columns = getLayoutSlot(e, 'default', false);
          const column1 = columns[index];
          const column2 = columns[index + 1];
          const col1Props = {
            ...column1.props
          };
          const col2Props = {
            ...column2.props
          };
          const oldW1 = col1Props.width;
          const oldW2 = col2Props.width;
          if (!oldW1 && !oldW2) {
            // 两个列都没有定宽，可以直接改权重就行

            const weight1 = col1Props.weight || 1;
            const weight2 = col2Props.weight || 1;
            const totalWeight = weight1 + weight2;

            // eslint-disable-next-line no-mixed-operators
            const percent = Math.round((dX + width1) / (width1 + width2) * quantizeFactor) / quantizeFactor;
            col1Props.weight = parseFloat((totalWeight * percent).toFixed(2));
            col2Props.weight = parseFloat((totalWeight * (1 - percent)).toFixed(2));
          } else {
            // 有存在定宽的列，改那些列的宽度值

            const tmpWidth1 = (width1 + dX).toFixed(2);
            const tmpWidth2 = (width2 - dX).toFixed(2);
            if (oldW1) col1Props.width = `${tmpWidth1}px`;
            if (oldW2) col2Props.width = `${tmpWidth2}px`;
          }
          this.$set(column1, 'props', col1Props);
          this.$set(column2, 'props', col2Props);
        });
      };
      const setPropsDebounced = throttle(setProps, 33);
      startMouseMove({
        initialEvent: event,
        onMove: v => {
          dX = Math.min(Math.max(v.deltaX * resizeFactor, -width1), width2);
          dX = Math.round(dX / widthQuantizeFactor) * widthQuantizeFactor;
          this.draggingDisplay = getDraggingDisplay();
          setPropsDebounced();
        },
        onEnd: async ({
          deltaX
        }) => {
          this.draggingIndex = -1;
          this.draggingDisplay = '';
          if (Math.abs(deltaX) < 5) {
            dX = 0;
            await setProps();
            return;
          }
          await setProps();
          this.$nextTick(() => {
            this.$forceUpdate();
            this.notifyPageletsChange(0);
          });
        }
      });
    }
  },
  computed: {
    addButtonTop() {
      return Math.max(0, this.visualHeight / 2 - 18);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "uc-rowDesignTool",
    class: {
      isHovering: _vm.isHovering
    },
    attrs: {
      "data-unused": _vm.syncSize()
    }
  }, _vm._l(_vm.columns, function (ref, index) {
    var leftPercent = ref.leftPercent;
    var widthPercent = ref.widthPercent;
    var rightPercent = ref.rightPercent;
    var props = ref.props;
    return _c('div', {
      key: index,
      staticClass: "uc-rowDesignTool-row"
    }, [false ? _c('div', {
      staticClass: "uc-rowDesignTool-rowToolbar",
      style: "width: " + widthPercent + "%; left: " + leftPercent + "%;"
    }, [_c('div', {
      staticClass: "uc-rowDesignTool-rowToolbarSection"
    }, [_c('button', {
      staticClass: "draggable-ignore",
      attrs: {
        "title": "设置定宽"
      },
      on: {
        "click": function ($event) {
          return _vm.setFixedWidth(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrows-h",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n          " + _vm._s(props.width ? "定宽 " + props.width : "" + (props.weight || 1).toFixed(2)) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "uc-rowDesignTool-rowToolbarSection"
    }, [_c('button', {
      staticClass: "draggable-ignore",
      attrs: {
        "title": "编辑列属性（请留意属性面板）"
      },
      on: {
        "click": function ($event) {
          return _vm.selectColumn(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "draggable-ignore",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteColumn(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e(), _vm._v(" "), index < _vm.columns.length - 1 && !props.width && !_vm.columns[index + 1].props.width ? _c('div', {
      key: 'resize' + index,
      staticClass: "uc-rowDesignTool-resizeHandler",
      style: "\n        top: " + _vm.visualHeight / 2 + "px;\n        left: " + (rightPercent + (_vm.columns[index + 1].leftPercent - rightPercent) / 2) + "%\n      "
    }, [_c('div', {
      staticClass: "ucd-absPosTool-resize",
      on: {
        "mousedown": function ($event) {
          return _vm.startResizing(index, $event);
        },
        "touchstart": function ($event) {
          return _vm.startResizing(index, $event);
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm.draggingIndex === index ? _c('div', {
      style: "\n        white-space: nowrap;\n        position:absolute;\n        height: " + _vm.addButtonTop + "px;\n        left: " + rightPercent + "%\n      "
    }, [_c('div', {
      staticClass: "ucd-absPosTool-tempValueDisplay"
    }, [_c('div', {
      staticClass: "ucd-absPosTool-tempValueDisplay-sizeDiv"
    }, [_c('span', [_vm._v(_vm._s(_vm.draggingDisplay))])])])]) : _vm._e(), _vm._v(" "), _c('FloatPortal', [index === 0 ? _c('div', {
      key: 'insertColumn:first',
      staticClass: "uc-rowDesignTool-insertColumn draggable-ignore",
      style: "top: " + _vm.addButtonTop + "px; left: 0;",
      on: {
        "click": function ($event) {
          return _vm.insertColumn(0);
        }
      }
    }, [_c('a-icon', {
      staticClass: "uc-rowDesignTool-insertColumn-handle icon",
      attrs: {
        "type": "plus-circle"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      key: 'insertColumn:' + index,
      staticClass: "uc-rowDesignTool-insertColumn draggable-ignore",
      style: "\n        top: " + _vm.addButtonTop + "px;\n        left: " + (rightPercent + (index < _vm.columns.length - 1 ? (_vm.columns[index + 1].leftPercent - rightPercent) / 2 : 0)) + "%\n      ",
      on: {
        "click": function ($event) {
          return _vm.insertColumn(index + 1);
        }
      }
    }, [_c('a-icon', {
      staticClass: "uc-rowDesignTool-insertColumn-handle icon",
      attrs: {
        "type": "plus-circle"
      }
    })], 1)])], 1);
  }), 0);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Row/RowDesignTool.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);